import { render, staticRenderFns } from "./OwnOffersClientsComponent.vue?vue&type=template&id=7c08f032&"
import script from "./OwnOffersClientsComponent.vue?vue&type=script&lang=js&"
export * from "./OwnOffersClientsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports